var _rect, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHsbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HSBC_MASTERBRAND_LOGO_WW_RGB",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 315.9 85",
    style: {
      enableBackground: "new 0 0 315.9 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.6,
    width: 85,
    height: 85,
    fill: "#ffffff"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HSBC_MASTERBRAND_LOGO_WW_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170.1,42.6 127.6,0 127.6,85.1",
    fill: "#db0011"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.1,42.6 127.6,0 42.6,0",
    fill: "#db0011"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0,42.6 42.6,85.1 42.6,0",
    fill: "#db0011"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.1,42.6 42.6,85.1 127.6,85.1",
    fill: "#db0011"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.4,45.1H192v15.2h-7.7V24.7h7.7v14.6h15.4V24.7h7.7v35.6h-7.7V45.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.7,61c-7.7,0-14-3.1-14.1-11.6h7.7c0.1,3.8,2.3,6.1,6.5,6.1c3.1,0,6.7-1.6,6.7-5.1c0-2.8-2.4-3.6-6.4-4.8l-2.6-0.7 c-5.6-1.6-11.2-3.8-11.2-10.2c0-7.9,7.4-10.6,14.1-10.6c6.9,0,12.9,2.4,13,10.3h-7.7c-0.3-3.2-2.2-5.1-5.8-5.1 c-2.9,0-5.7,1.5-5.7,4.7c0,2.6,2.4,3.4,7.4,5l3,0.9c6.1,1.9,10,4,10,10C248.5,57.9,240.7,61,233.7,61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.9,24.8h12.4c2.3-0.1,4.7,0,7,0.4c4.3,1,7.6,3.8,7.6,8.6c0,4.6-2.9,6.9-7.1,8c4.8,0.9,8.4,3.3,8.4,8.6 c0,8.1-8,9.9-14.2,9.9h-14L252.9,24.8z M265.3,39.6c3.4,0,6.9-0.7,6.9-4.8c0-3.7-3.2-4.7-6.4-4.7h-5.4v9.5H265.3z M266,55 c3.6,0,7.1-0.8,7.1-5.2s-3-5.2-6.7-5.2h-6.1V55H266z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.2,61c-11.5,0-16.6-7.3-16.6-18.2s5.7-18.8,17-18.8c7.1,0,14,3.2,14.2,11.2h-8c-0.4-3.6-2.8-5.4-6.2-5.4 c-7,0-9.1,7.5-9.1,13.2c0,5.7,2.1,12.3,8.8,12.3c3.5,0,6.1-1.9,6.6-5.5h8C315.1,58,308.6,61,301.2,61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsbc);
export default __webpack_public_path__ + "static/media/HSBC.b8af702922e0ea1a74c9b29216d02e30.svg";
export { ForwardRef as ReactComponent };